import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import { useNavigate } from "react-router-dom/dist";

import "./DownloadManagement.scss";
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import DownloadServices from "../../services/api/DownloadServices";
import NewDownload from './NewDownload';
import { useMainContext } from "../../dataproviders/MainDataProvider";
import { useDownloadContext } from "../../dataproviders/DownloadDataProvider";
import { useAuthContext } from '../../dataproviders/AuthDataProvider';

function DownloadManagement() {
    const mainContext = useMainContext();
    const authContext = useAuthContext();
    const downloadContext = useDownloadContext();
    const navigate = useNavigate();
    const gridRef = useRef(); // Optional - for accessing Grid's API
    const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
    const [containerHeight, setContainerHeight] = useState(0); // Initialize containerHeight
    const [isMobileScreen, setIsMobileScreen] = useState(false); // Initialize the mobile screen state
    //const [errors, setErrors] = useState([]);
    //const [password, setPassword] = useState("default");
    //const [invalidPasswordError, setInvalidPasswordError] = useState(false);

    class DownloadManagementCellRenderer {
        init(params) {
            this.params = params;
            this.eGui = this.createContextMenu();
        }

        createContextMenu() {
            const contextMenu = document.createElement('div');
            contextMenu.classList.add('context-menu');
            contextMenu.classList.add('dropdown');
            contextMenu.classList.add('dropdown-downloadmgmt');

            const toggleBtn = document.createElement('button');
            toggleBtn.classList.add('dropdown-toggle');
            toggleBtn.setAttribute('type', 'button');
            toggleBtn.innerHTML = '<i class="fa-solid fa-ellipsis-vertical"></i>';
            toggleBtn.addEventListener('click', this.toggleHandler);

            const dropdownMenu = document.createElement('div');
            dropdownMenu.classList.add('dropdown-menu');

            // delete download
            const deleteDownloadBtn = document.createElement('button');
            deleteDownloadBtn.classList.add('dropdown-item');
            deleteDownloadBtn.classList.add('dropdown-item-top-border');
            deleteDownloadBtn.innerHTML = '<i class="fa-regular fa-trash-can"></i> Delete';
            this.deleteDownloadHandler = this.deleteDownloadHandler.bind(this);
            deleteDownloadBtn.addEventListener('click', this.deleteDownloadHandler);

            // Check if data.status === 0 to enable/disable the delete button
            if (this.params.data.status === 0) { //pending
                deleteDownloadBtn.disabled = false; // Enable the button
                this.deleteDownloadHandler = this.deleteDownloadHandler.bind(this);
                deleteDownloadBtn.addEventListener('click', this.deleteDownloadHandler);
            } else {
                deleteDownloadBtn.disabled = true; // Disable the button
                deleteDownloadBtn.classList.add('disabled'); // Add a class to style it as disabled
            }

            // add buttons to dropdown menu
            dropdownMenu.appendChild(deleteDownloadBtn);

            contextMenu.appendChild(toggleBtn);
            contextMenu.appendChild(dropdownMenu);
            return contextMenu;
        }

        getGui() {
            return this.eGui;
        }

        toggleHandler(e) {
            let el = e.target.closest('.dropdown-downloadmgmt').querySelector('.dropdown-menu');

            // Check if the element has the .show class
            if (el.classList.contains('show')) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-downloadmgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });
            }
            else {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-downloadmgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });

                const dropdownMenu = el;
                dropdownMenu.classList.toggle('show');

                e.target.closest('.dropdown-downloadmgmt').classList.toggle('col-rps-light');
            }

            const container = document.querySelector('.download-management-container');
            const targetElement = container.querySelector('.dropdown-menu.show');

            if (targetElement) {
                const containerScrollHeight = container.scrollHeight;
                const containerRect = container.getBoundingClientRect();
                const targetElementRect = targetElement.getBoundingClientRect();

                const targetTop = targetElementRect.top - containerRect.top + container.scrollTop;
                const targetHeight = targetElementRect.height;

                if (targetTop + targetHeight > containerScrollHeight) {
                    targetElement.style.top = (-targetHeight) + 'px';
                }
            }

        }

        deleteDownloadHandler(e) {
            const container = document.querySelector('.dialog-overlay-delete');

            if (container) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-downloadmgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });

                container.classList.remove('hide');

                const btn = document.querySelector('.btn-download-delete');
                btn.setAttribute('downloadid', this.params.data.downloadid);
            }
        }

        destroy() {
            this.eGui.removeEventListener('click', this.toggleHandler);
            this.eGui.removeEventListener('click', this.deleteDownloadHandler);
        }
    }

    const CustomListFilterStatus = () => {
        const [selectedValues, setSelectedValues] = useState(-1);

        const handleOnChange = (event) => {
            setSelectedValues(event.target.value);

            let grid = (gridRef.current && gridRef.current.api ? gridRef : null);

            if (grid != null) {
                // Get a reference to the filter instance
                let value = event.target.value === "-1" ? null : event.target.value;

                if (value == null) {
                    // Set the filter model
                    grid.current.api.setColumnFilterModel('status', null);
                }
                else {
                    // Set the filter model
                    grid.current.api.setColumnFilterModel('status', {
                        filterType: 'text',
                        type: 'equals',
                        filter: value
                    });
                }

                // Tell grid to run filter operation again
                grid.current.api.onFilterChanged();
            }
        };

        // Render method
        return (
            <div className="ag-custom-filter-list">
                <select
                    className="ag-custom-filter-select"
                    value={selectedValues}
                    onChange={handleOnChange} id="aggrid-status"
                >
                    {/* Options for dropdown */}
                    <option value="-1">All</option>
                    <option value="0">Pending</option>
                    <option value="1">Processing</option>
                    <option value="2">Completed</option>
                    <option value="3">Error</option>
                    <option value="4">Deleted</option>
                </select>
            </div>
        );
    };

    const StatusCellRenderer = (params) => {
        var text = '';
        if (params.data.status === 1) {
            text = 'Processing';
        }
        else if (params.data.status === 2) {
            text = 'Completed';
        }
        else if (params.data.status === 3) {
            text = 'Error';
        }
        else if (params.data.status === 4) {
            text = 'Deleted';
        }
        else {
            text = 'Pending';
        }

        return (
            (params.data.status === 2) ? <a className="link col-green" href={params.data.downloadurl} target="_blank" rel="noreferrer">{text}</a> : <>{text}</>
        );
    };

    // Each Column Definition results in one Column.
    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: '',
            field: 'downloadid',
            cellClass: ['actions-button-cell'],
            cellRenderer: DownloadManagementCellRenderer,
            minWidth: 24,
            maxWidth: 24,
            sortable: false,
            filter: false,
            resizable: false
        },
        {
            headerName: '',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'vesselid',
            hide: true
        },
        {
            headerName: '',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'deviceid',
            hide: true
        },
        {
            headerName: '',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'downloadurl',
            hide: true
        },
        {
            headerName: 'Start Date',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'startdate',
            filter: 'agDateColumnFilter',
            cellRenderer: params => {
                if (params.value && params.value !== undefined && params.value !== null && params.value.trim() !== '') {
                    return params.value.slice(0, -4);
                }
                else {
                    return params.value;
                }
            },
            minWidth: 150,
            maxWidth: 150,
            flex: 1
        },
        {
            headerName: 'End Date',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'enddate',
            filter: 'agDateColumnFilter',
            cellRenderer: params => {
                if (params.value && params.value !== undefined && params.value !== null && params.value.trim() !== '') {
                    return params.value.slice(0, -4);
                }
                else {
                    return params.value;
                }
            },
            minWidth: 150,
            maxWidth: 150,
            flex: 1
        },
        {
            headerName: 'Vessel',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'vesselname',
            cellRenderer: params => {
                return params.data.vesselname + ' (' + params.data.devicename + ')';
            },
            flex: 1,
            minWidth: 250
        },
        {
            headerName: 'Status',
            field: 'status',
            maxWidth: 120,
            minWidth: 120,
            filter: false,
            cellRenderer: StatusCellRenderer,
            tooltipValueGetter: params => {
                if (params.data.status === 3) {
                    let errorMessage = params.data.errormessage;

                    // Check if errorMessage is null or empty
                    if (!errorMessage || params.value === undefined || params.value === null || errorMessage.trim() === '') {
                        errorMessage = 'Unknown error.'; // or any default message you prefer
                    } else {
                        // Check if the last character is not a period
                        if (errorMessage.charAt(errorMessage.length - 1) !== '.') {
                            errorMessage += '.';
                        }
                    }

                    return "An error occurred due to " + errorMessage;
                }
            }                    ,
            cellClass: params => {
                if (params.data.status === 1) {
                    return ['d-flex', 'text-wrap', 'col-orange', 'ag-cell-custom-text'];
                }
                if (params.data.status === 2) {
                    return ['d-flex', 'text-wrap', 'col-green', 'ag-cell-custom-text'];
                }
                else if (params.data.status === 3) {
                    return ['d-flex', 'text-wrap', 'col-red', 'ag-cell-custom-text', 'ag-cell-underline-text'];
                }
                else if (params.data.status === 0) {
                    return ['d-flex', 'text-wrap', 'col-yellow', 'ag-cell-custom-text'];
                }
                else {
                    return ['d-flex', 'text-wrap', 'ag-cell-custom-text'];
                }
            },
            resizable: false
        },
        {
            headerName: 'Created Date',
            cellClass: ['ag-cell-custom-text'],
            field: 'createddate',
            filter: 'agDateColumnFilter',
            cellRenderer: params => {
                if (params.value && params.value !== undefined && params.value !== null && params.value.trim() !== '') {
                    return params.value.slice(0, -4);
                }
                else {
                    return params.value;
                }
            },
            resizable: true,
            minWidth: 150,
            maxWidth: 150,
            flex: 1
        },
        {
            headerName: 'Creator',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'createdby',
            resizable: true,
            minWidth: 180,
            maxWidth: 180,
            flex: 1
        }
    ]);

    const sizeToFit = useCallback(() => {
        // Check if gridRef.current is not null before accessing the 'api' property
        if (gridRef.current) {
            gridRef.current.api.sizeColumnsToFit({
                defaultMinWidth: 100
            });
        }
    }, []);

    const handleResize = useCallback(() => {
        // Calculate the new container height on window resize
        const newContainerHeight = window.innerHeight - 350;
        setContainerHeight(newContainerHeight);

        // Detect mobile screen size (width <= 768px)
        const isMobile = window.innerWidth <= 768;
        setIsMobileScreen(isMobile);

        sizeToFit();
    }, []);

    // DefaultColDef sets props common to all Columns
    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        suppressMovable: true,
        // override all the defaults with font awesome
        icons: {
            // use font awesome for menu icons
            menu:'<i class="fa-solid fa-filter"></i>'
        }
    }));

    // Example of consuming Grid Event
    const cellClickedListener = useCallback(e => {
        const headerName = e.colDef.headerName;
        const colIndex = e.api
            .getColumns()
            ?.findIndex((col) => col.getColDef().headerName === headerName);

        //if not first cell, go inside to hide all
        if (colIndex > 0) {
            //hide all dropdown-menu with .show
            const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
            dropdownMenus.forEach((dropdownMenu) => {
                dropdownMenu.classList.remove('show');
            });

            //hide all dropdown-menu with .show
            const dropdownMenusMgmt = document.querySelectorAll('.dropdown-downloadmgmt.col-rps-light');
            dropdownMenusMgmt.forEach((dropdownMenu) => {
                dropdownMenu.classList.remove('col-rps-light');
            });
        }

    }, []);

    useEffect(() => {
        // Add event listener for screen size change
        window.addEventListener('resize', handleResize);
        return () => {
            // Cleanup: remove event listener on component unmount
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (rowData !== undefined) {
            handleResize();
        }
    }, [rowData]); // Add rowData as a dependency so that this useEffect only runs when rowData changes

    // Example load data from server
    useEffect(() => {
        const _auth = JSON.parse(sessionStorage.getItem("auth"));
        let intervalId;

        const fetchDownloads = () => {
            if (!!_auth) {
                const role = _auth.role;

                // 0: Admin, 1: Operator, 2: Project Manager, 3: Client
                if (role === 0 || role === 2) {
                    getDownloads();
                } else {
                    navigate("/projects");
                }
            } else {
                getDownloads();
            }

            downloadContext.SetRefreshFlag(false);
        };

        if (downloadContext.RefreshFlag) {
            fetchDownloads(); // Initial fetch
        }

        intervalId = setInterval(() => {
            fetchDownloads();
        }, 30000); // 30 seconds refresh

        return () => clearInterval(intervalId); // Cleanup on component unmount

    }, [downloadContext.RefreshFlag]);

    const getDownloads = async () => {
        const result = await DownloadServices.GetDownloads();

        if (!!result) {
            setRowData(result.data);
        }
    };

    const handleDelete = async (e) => {
        const cancelButton = e.currentTarget;
        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');
            let downloadid = cancelButton.getAttribute('downloadid');
            const flag = await DownloadServices.DeleteDownload(downloadid);
            if (!!flag) {
                if (typeof flag.data.errormessage === 'undefined' || flag.data.errormessage === null || flag.data.errormessage === "") {
                    const result = await DownloadServices.GetDownloads();
                    if (!!result) {
                        setRowData(result.data);
                    }
                    let downloadname = cancelButton.getAttribute('downloadname');
                    handleError('Success', downloadname + " download has been deleted.");
                }
                else {
                    // Display error message for network errors
                    handleError('Error', `Download has failed to delete due to ${flag.data.errormessage.toLowerCase()} Please try again.`);
                }
            }
            else {
                // Display error message for network errors
                handleError('Error', 'Download has failed to delete due to system error. Please try again.');
            }
            hideDelete(cancelButton);
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
    };

    const handleCancelDelete = (e) => {
        const cancelButton = e.currentTarget;
        hideDelete(cancelButton);
    };
    const handleError = (errorType, errorMessage) => {
        authContext.HandleError(errorType,errorMessage);
    }

    const hideDelete = (btn) => {
        const dialogOverlay = btn.closest('.dialog-overlay-delete');
        if (dialogOverlay) {
            dialogOverlay.classList.add('hide');
        }
    };

    return (
        <>
            <div className="download-management-container" style={{ minHeight: '295px', height: `${!isMobileScreen ? `${containerHeight}px` : '100vh'}` }}>
                <div className="sub-title container-link col-red">* Records are available for the most recent three days only and will refresh every 30 seconds.</div>
                {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
                <div className="ag-theme-alpine download-management-with-context-menu" style={{ width: '100%', height: '100%' }}>

                    <AgGridReact
                        ref={gridRef} // Ref for accessing Grid's API

                        rowData={rowData} // Row Data for Rows
                        headerHeight={30}
                        rowHeight={30}
                        columnDefs={columnDefs} // Column Defs for Columns
                        defaultColDef={defaultColDef} // Default Column Properties
                        
                        enableBrowserTooltips={true}

                        animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                        rowSelection='single' // Options - allows click selection of rows
                        suppressMenuHide={true}
                        // Your grid options here....
                        suppressCellSelection={true}
                        onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                    />
                </div>
                <div className="dialog-overlay dialog-overlay-delete hide">
                    <div className="dialog-container">
                        <button className="dialog-close-button font-big" onClick={handleCancelDelete}>
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <p className="dialog-title col-rps-light mt-0 mb-0">Delete Download</p>
                        <p className="dialog-content">Are you sure wish to delete record?</p>
                        <div className="dialog-buttons float-right">
                            <button className="btn btn-dialog btn-primary btn-me btn-download-delete" onClick={handleDelete}>Yes</button>
                            <button className="btn btn-dialog btn-secondary" onClick={handleCancelDelete}>No</button>
                        </div>
                    </div>
                </div>
            <NewDownload />
            </div>
        </>
    );
}

export default DownloadManagement;
